<h1 mat-dialog-title>Ukryj/pokaż kolumny</h1>
<div mat-dialog-content>
	<ul class="list-inline">
		<li class="list-inline-item" *ngFor="let item of data.columns">
			<button
				mat-raised-button
				class="mb-2"
				*ngIf="item.header && item.col !== 'number'"
				[color]="data.settings.hiddenColumns.includes(item.col) ? 'basic' : 'primary'"
				(click)="showHideRow(item.col, item.size)"
			>
				{{ item.header }}
			</button>
		</li>
	</ul>
</div>
